import { useQuery } from "@tanstack/react-query";

import { getCTAs } from "./fetch";
import { giveKeys } from "./keys";

export const useGetCTAs = ({ fundID, enabled }) => {
  return useQuery({
    queryKey: giveKeys.ctas(fundID),
    queryFn: () => getCTAs({ fundID }),
    enabled,
  });
};
